import React, { useRef, useState } from 'react';
import { usePopoverContext } from '@fiverr-private/popover';
import { useBreakpoint } from '@fiverr-private/hooks';
import { getContext } from '@fiverr-private/fiverr_context';
import { DropdownProps, MenuItem, MenuItems } from '../types';
import { DropdownContext } from '../useDropdownContext';
import useDropdownState from '../useDropdownState';

const DropdownContextProvider = ({
  children,
  onChange,
  values,
  defaultValues,
  searchWhenClosed,
  keyboardNavigationLoop,
  searchOnKeyPress,
  selectedIndicatorPosition,
  theme,
  shouldStopPropagation,
}: DropdownProps) => {
  const [focusedItem, setFocusedItem] = useState<MenuItem['ref']>({} as MenuItem['ref']);
  const state = useDropdownState({ onChange, values, defaultValues });
  const anchorRef = useRef<HTMLElement>(null);
  const headerActionsRef = useRef<HTMLElement>(null);
  const footerActionsRef = useRef<HTMLElement>(null);
  const items = useRef<MenuItems>([]).current;
  const isMultiSelect = useRef(null);
  const breakpoint = useBreakpoint();
  const { isMobile } = getContext();
  const isMobileView = breakpoint === 'default' || isMobile;
  const popoverContext = usePopoverContext();

  return (
    <DropdownContext.Provider
      value={{
        ...state,
        isMobileView,
        searchWhenClosed,
        anchorRef,
        items,
        focusedItem,
        setFocusedItem,
        keyboardNavigationLoop,
        isMultiSelect,
        searchOnKeyPress,
        selectedIndicatorPosition,
        popoverContext,
        headerActionsRef,
        footerActionsRef,
        isDark: theme === 'dark',
        shouldStopPropagation,
      }}
    >
      {children}
    </DropdownContext.Provider>
  );
};

export default DropdownContextProvider;
